var map = {
	"./News02.vue": [
		"3dee",
		"chunk-2d0c53e7"
	],
	"./News03.vue": [
		"c9bf",
		"chunk-094ceb90"
	],
	"./News04.vue": [
		"4e46",
		"chunk-4fd5afde"
	],
	"./News05.vue": [
		"f853",
		"chunk-67d9e010"
	],
	"./News06.vue": [
		"bd1e",
		"chunk-7401f3d6"
	],
	"./News07.vue": [
		"db12",
		"chunk-7080a6f4"
	],
	"./News08.vue": [
		"093a",
		"chunk-2d0a4f4d"
	],
	"./News09.vue": [
		"253b",
		"chunk-2d0b2908"
	],
	"./News10.vue": [
		"4cc1",
		"chunk-2d0cc413"
	],
	"./News11.vue": [
		"bed8",
		"chunk-2d21b4cd"
	],
	"./News13.vue": [
		"f0b8",
		"chunk-2d22bf16"
	],
	"./News16.vue": [
		"d695",
		"chunk-2d21e7e4"
	],
	"./News17.vue": [
		"16c1",
		"chunk-927e37b2"
	],
	"./News18.vue": [
		"9ed0",
		"chunk-2d0f118e"
	],
	"./News21.vue": [
		"acf9",
		"chunk-72703b8e"
	],
	"./News22.vue": [
		"cc2f",
		"chunk-cc7798d6"
	],
	"./News24.vue": [
		"b8c8",
		"chunk-2d210bc1"
	],
	"./News25.vue": [
		"a37d",
		"chunk-e95eb3a4"
	],
	"./News26.vue": [
		"7aaf",
		"chunk-2d0e19a5"
	],
	"./News28.vue": [
		"3eda",
		"chunk-7858df68"
	],
	"./News29.vue": [
		"ef79",
		"chunk-2d231039"
	],
	"./News30.vue": [
		"f6bb",
		"chunk-2d22d5c6"
	],
	"./News31.vue": [
		"1e4e",
		"chunk-6b908ca3"
	],
	"./News32.vue": [
		"f37b",
		"chunk-2d22c54e"
	],
	"./News33.vue": [
		"122f",
		"chunk-2d0aa94b"
	],
	"./News34.vue": [
		"a15f",
		"chunk-2d2077b7"
	],
	"./News35.vue": [
		"0987",
		"chunk-2d0a4fbe"
	],
	"./News36.vue": [
		"f592",
		"chunk-2d22ccde"
	],
	"./News37.vue": [
		"294d",
		"chunk-2d0b382d"
	],
	"./News38.vue": [
		"ba6a",
		"chunk-2d21a060"
	],
	"./News39.vue": [
		"44a4",
		"chunk-2d0c1369"
	],
	"./News40.vue": [
		"cedf",
		"chunk-2d22295a"
	],
	"./News41.vue": [
		"4f5a",
		"chunk-2d0cc9f4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2ea6";
module.exports = webpackAsyncContext;